import React from 'react';
import styled from 'styled-components';

import { SkeletonBlock } from '@/components/common/loaders/SkeletonBlock';

const ResourceDatabaseTableSkeleton = (): React.ReactElement => (
  <SkeletonContainer>
    <SkeletonTitleSection />
    <SkeletonTableSection />
  </SkeletonContainer>
);

export { ResourceDatabaseTableSkeleton };

const SkeletonContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const SkeletonTitleSection = styled(SkeletonBlock)`
  height: 36px;
`;

const SkeletonTableSection = styled(SkeletonBlock)`
  height: 300px;
`;
